import { instance } from "../axios/axiosConfig";
import {
  ChangeEmailBodyType,
  ChangePasswordBodyType,
} from "../types/profileTypes.tsx";

const profileApi = {
  fetchProfileData() {
    return instance.get(`/api/profile-settings/`);
  },
  editProfileData(body: FormData) {
    return instance.post(`/api/profile-settings/`, body, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
  },
  changeEmailProfileData(body: ChangeEmailBodyType) {
    return instance.post(`/api/change-email/`, body);
  },
  changePassword(body: ChangePasswordBodyType) {
    return instance.post(`/api/change-password/`, body);
  },
  fetchStates(id: number) {
    return instance.get(`/api/states/`, { params: { country_id: id } });
  },
  fetchPlatforms() {
    return instance.get(`/api/platforms/`);
  },
};

export default profileApi;
